/**
 * Despia native wrapper helpers.
 * Despia injects "despia" into the user agent and handles `scheme://` bridge URLs
 * when assigned to window.location.
 */
export type NativePlatform = "web" | "ios" | "android";

export function getNativePlatform(): NativePlatform {
  if (typeof navigator === "undefined") return "web";
  const ua = navigator.userAgent.toLowerCase();
  if (!ua.includes("despia")) return "web";
  if (/iphone|ipad|ipod|ios/.test(ua)) return "ios";
  if (ua.includes("android")) return "android";
  return "ios";
}

export const isNativeApp = () => getNativePlatform() !== "web";

/** Fire a Despia bridge command (no-op on the web). */
export function despiaCommand(url: string) {
  if (!isNativeApp()) return;
  window.location.href = url;
}

/** Start an App Store / Google Play purchase through Despia's RevenueCat bridge. */
export function nativePurchase(userId: string, productId: string) {
  despiaCommand(
    `revenuecat://purchase?external_id=${encodeURIComponent(userId)}&product=${encodeURIComponent(productId)}`,
  );
}

export function nativeRestorePurchases(userId: string) {
  despiaCommand(`revenuecat://restore?external_id=${encodeURIComponent(userId)}`);
}

/** Open the store's own subscription management screen. */
export function openStoreSubscriptions() {
  const url =
    getNativePlatform() === "android"
      ? "https://play.google.com/store/account/subscriptions"
      : "https://apps.apple.com/account/subscriptions";
  window.open(url, "_blank", "noopener");
}

/** Despia exposes the OneSignal player id on window when push is enabled. */
export function getNativePushToken(): string | null {
  const w = window as unknown as { despia?: { onesignalplayerid?: string }; onesignalplayerid?: string };
  return w.despia?.onesignalplayerid || w.onesignalplayerid || null;
}
